import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export default function NewsroomScreenListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.NewsroomScreenListing', {
		url: '/newsroom/screens',
		controllerAs: 'vm',
		controller: NewsroomScreenListingCtrl,
		templateUrl: '/ng/hub/Newsroom/Screen/Listing/NewsroomScreenListingCtrl.html?' + window.BUILD,
		permission: ['publish'],
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Newsroom/Screen/Listing/NewsroomScreenListingCtrl.css'),
			$title: () => 'Newsroom Screens',
			screens: ApiResourcify.endpoint('/newsrooms/screens'),
			screenTypes: ApiResourcify.endpoint('/newsrooms/screens/types', {
				cacheFor: 30 * 60 * 1000,
			}),
		},
	});
}

class NewsroomScreenListingCtrl {
	constructor(screens, clipboard, notifications, $state, Api, modal, screenTypes) {
		'ngInject';
		this.Api = Api;
		this.$state = $state;
		this.screens = screens;
		this.clipboard = clipboard;
		this.notifications = notifications;
		this.modal = modal;
		this.sortBy = '-created_at';
		// get a list of type names by type code e.g. {masonry:'Masonry'...}
		this.screenTypes = _.indexBy(screenTypes, 'type');
	}

	copyLink(screen, $event) {
		try {
			screen.showSecretUrl = false;
			this.clipboard.copyText(screen.secretUrl);
			this.notifications.showSuccess(`
				<strong>Secret link copied to clipboard.</strong>
				You can send the link to a computer that runs your newsroom.
				Any edits you make here will automatically update any running newsrooms.
			`);
		} catch (ex) {
			// Clipboard exceptions probably mean it is Safari
			// this.showSecretUrl will cause the template to show an input box;
			// After shown, select contents of input box for easier copying
			screen.showSecretUrl = true;
			setTimeout(() => {
				$event.target.nextSibling.select();
			}, 0);
		}
	}

	getScreenTypeImgSrc(screen) {
		return screen.preview || this.screenTypes[screen.type].icon;
	}

	addScreen() {
		let modalOptions = {
			heading: 'Screen Type',
			width: 800,
			height: 360,
		};
		this.modal.state('hub.loggedin.NewsroomChooser', modalOptions);
	}

	delete(screen) {
		this.modal.confirm({ text: 'Are you sure you want to delete this screen?' }).then(() => {
			this.Api.delete('/newsrooms/screens/' + screen.id).then(() => {
				this.screens.splice(this.screens.indexOf(screen), 1);
			});
		});
	}
}
